module.exports = __webpack_public_path__ + "img/stock7.61ac2822.png";